import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { CATEGORY_META } from "../lib/categories";

export default function Categories() {
  const [cats, setCats] = useState([]);
  useEffect(() => { api.get("/categories").then((r) => setCats(r.data)); }, []);

  return (
    <div className="mx-auto max-w-7xl px-6 lg:px-8 py-16" data-testid="categories-page">
      <div className="mb-10">
        <div className="text-xs font-mono-tag uppercase tracking-[0.2em] text-zinc-400 mb-2">/ Directory</div>
        <h1 className="font-display text-5xl tracking-tight">All categories</h1>
        <p className="mt-3 text-zinc-600 max-w-xl">Pick an industry to browse vetted B2B providers in your space.</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {cats.map((c, idx) => {
          const meta = CATEGORY_META[c.slug] || {};
          const Icon = meta.Icon;
          return (
            <Link
              key={c.slug}
              to={`/category/${c.slug}`}
              data-testid={`cat-tile-${c.slug}`}
              className="card-lift rounded-lg border border-zinc-200 bg-white p-6 flex items-center gap-4 reveal"
              style={{ animationDelay: `${Math.min(idx * 25, 280)}ms` }}
            >
              <div className="h-12 w-12 rounded-md grid place-items-center text-white shrink-0" style={{ background: meta.accent || "#0F172A" }}>
                {Icon && <Icon className="h-6 w-6" />}
              </div>
              <div className="flex-1">
                <div className="font-display text-xl leading-tight">{c.name}</div>
                <div className="text-xs text-zinc-500 mt-1">{c.count} provider{c.count === 1 ? "" : "s"}</div>
              </div>
              <div className="font-mono-tag text-zinc-300 text-xs">→</div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
